<template>
	<!-- >>> Filter TextField -->
	<div style="display:flex;flex:0.2 1 auto;">
		<v-combobox
			v-if= "get_shared_IsDutyAccessAllowed === true"
			v-model="selectedResourceId"
			style="margin-top:22px;margin-left:60px;"
			:items="get_ResourcesOfDepartment"
			item-text="filterableName"
			label="Search here for Resources..."
			@change="onChange_searchResources"
			clearable
			:disabled= "selectedResourceId !== 'ONE MOMENT. STILL LOADING..'? false : true">
		</v-combobox>

		<v-combobox
			v-if= "get_shared_IsDutyAccessAllowed !== true"
			v-model="get_FullMemberName"
			style="margin-top:22px;margin-left:60px;"
			label="Search here for Resources..."
			disabled>
		</v-combobox>
	</div>
	<!-- <<< Filter TextField -->
</template>

<script>
	import Vue from 'vue';
	import { mapActions, mapGetters } from 'vuex';

	import { eventBus } from '../../../../../main';
	import dayjs from 'dayjs';


	export default {
		name: 'SearchBox2',


		/* >>> *************************************************************** / /* Data */
		data: function () {

			return {
				selectedResourceId: 'ONE MOMENT. STILL LOADING..',
			};

		}, // eo data()
		/* <<< ****************************************************************/



		/* >>> *************************************************************** / /* Computed */
		computed: {

			...mapGetters([
				'get_ResourcesOfDepartment',
				'getIdResource',
				'getIdGroup',
				'get_shared_IsDutyAccessAllowed',
				'get_FullMemberName'
			])

		}, // eo computed{}
		/* <<< ****************************************************************/



		/* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function() {

			// resets the selectedResourceId
			eventBus.$on('departmentsareloaded', () => {
				this.selectedResourceId = '';
			});

		}, // eo function created()


        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note:
        *
        */
		mounted: function() {

			if (this.get_shared_IsDutyAccessAllowed !== true) {
				this.onChange_searchResources({ id: this.getIdResource });
			};

		}, // eo function mounted()
        /* <<< ****************************************************************/



		/* >>> *************************************************************** / /* Methods */
		methods: {

			...mapActions([
				'actn_setResource',
			]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
			/*******************************************************************
            * onChange_searchResources()
            *
            * Desc: Save 'idResource'.
			* Note: 2-3, Load Vacation Report.
			* Note:
            *
            */
			onChange_searchResources: function(e) {

				let me = this;


				me.$toc('>>> views/vacations/statusoverview/components/core/SearchBox.vue >>> onChange_searchResources');
				if (e && e.id !== undefined) {
					this.actn_setResource(e.id); // idResource
				}

				if (e === undefined) {
					this.actn_setResource(null); // idResource
				}

			} // eo function onChange_searchResources()

		} // eo methods{}
		/* <<< ****************************************************************/
	};
</script>
